import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientNetsuite: string;

export interface ISyncPreviewSummary {
    depleted_units: number;
    depleted_value: number;
    depleted_skus: number;
    added_units: number;
    added_value: number;
    added_skus: number;
}

export interface NetsuiteProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
    previewSummary?: ISyncPreviewSummary;
}

const PREVIEW_COMPLETE = "Synchronization preview complete";
const PREVIEW_READY_TEXT = "Adjustments Preview is Ready For Review";

class NetsuiteProgressUpdate {
    netsuiteProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientNetsuited= (typeof isClientNetsuite === "undefined") ? false : isClientNetsuite;
        if(isClientNetsuited == 'true'){
            this.netsuiteProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Netsuite::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `netsuite_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Netsuite Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Netsuite Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
            $(document).on("click", ".js-refresh-preview", () => this.refreshPreview());
            this.reopenDialog();
        }

    }

    // SC-6244: reopen the Sync dialog on the Compare page when a recent preview was not synced yet (the server renders
    // #netsuite-sync-reopen with its totals), or when the Sync Preview page sent the user here with
    // ?sync_dialog=netsuite&run=preview (Refresh) or run=sync (Continue and Sync to NetSuite).
    reopenDialog(): void {
        const holder = $("#netsuite-sync-reopen");
        // Not #download_netsuite: the Compare page gives that id to Download Quantities too (first), so match the Sync link by its URL (href, or data-url once the page has moved it there).
        const link = $("a[href*='/show_sync_to_netsuite_modal'], a[data-url*='/show_sync_to_netsuite_modal']").first();
        if (!holder.length || !link.length) {
            return;
        }
        const query = window.location.search;
        const run = /[?&]sync_dialog=netsuite(&|$)/.test(query) ? ((query.match(/[?&]run=(preview|sync)/) || [])[1] || "") : "";
        const summaryData = holder.attr("data-summary");
        const summary: ISyncPreviewSummary | null = summaryData ? JSON.parse(summaryData) : null;
        if (!run && !summary) {
            return;
        }
        if (run) {
            window.history.replaceState(null, "", window.location.pathname); // a reload must not run it again
        }
        $(document).one("shown.bs.modal", "#sync-quantities-dialog", () => {
            if (run === "preview") {
                $(".netsuitecontinueBtn").trigger("click");
                return;
            }
            if (!summary) {
                return; // nothing recent to continue from: the dialog starts from the beginning
            }
            this.showReadyState(summary, holder.attr("data-preview-url"));
            if (run === "sync") {
                $(".sync-actions > .netsuiteSyncBtn").trigger("click");
            }
        });
        link.trigger("click");
    }

    showReadyState(summary: ISyncPreviewSummary, previewUrl: string): void {
        $("#download-qty-checkbox").hide();
        $(".continue-button-wrapper").hide();
        $(".sync-actions").removeClass("hide");
        $(".previewSyncBtn").attr("href", previewUrl).removeAttr("disabled").show();
        $(".sync-actions > .netsuiteSyncBtn").removeAttr("disabled").show();
        $(".currentStatus").removeClass("hide").show();
        $(".currentStatus .progress-spin, .currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatusDesc_Category").css("color", "").text(PREVIEW_READY_TEXT);
        this.showPreviewSummary({ message: PREVIEW_COMPLETE, progress: 100, inProgress: false, success: true, previewSummary: summary });
    }

    updateProgress(data: NetsuiteProgressChannelData) {
        console.log(data);

      const inSyncDialog = $("#sync-quantities-dialog").is(":visible");
      $(".currentStatusDesc_Category").text(data.message == PREVIEW_COMPLETE ? PREVIEW_READY_TEXT : `${data.message}`);
      this.showPreviewSummary(data);
      if (data.inProgress) {
        // SC-6244: a run started (here or in another tab): no Proceed / Refresh until it is finished.
        $(".sync-actions > .netsuiteSyncBtn, .js-refresh-preview").attr("disabled", "disabled");
      }

      if (data.message == "Account or Subsidiary ID is missing" || data.message == "Account Id is not associated with the Subsidiary") {
        $(".sync-actions > .previewSyncBtn").hide();
        $(".sync-actions > .netsuiteSyncBtn").hide();
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatusDesc_Category").css("color", "red");
        return;
      }

        $("#netsuite_sync").show();
        $("#netsuite_qty_sync").show();
        $("#netsuite_sync_btn").hide();
        $("#last_update").hide();
        $("#netsuite_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#netsuiteProgressLabel").text(`${data.progress}%`);


      if (!data.inProgress && !data.success) {
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").hide();
        $(".currentStatus .fail-img").removeClass("hide").show();
        $(".currentStatusDesc_Category").css("color", "red");
        $("#netsuite_sync_progress").removeClass("blink");
        $("#netsuite_qty_sync .progress-bar").addClass("progress-bar-danger");
        return;
      }

      const catSyncDialogOpen = $("#syncCategoriesDialog").is(":visible");

      if (data.message == "Synchronization preview complete") {
        $("#netsuite_qty_sync").hide();
        if (!inSyncDialog && !catSyncDialogOpen) {
          setTimeout(() => this.refresh(), 2000);
          return;
        }
      }

      if (data.message == "Synchronization preview complete" && inSyncDialog) {
        $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
        $(".sync-actions > .netsuiteSyncBtn").removeAttr("disabled");
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        return;
      }

      const catSyncDialog = $("#syncCategoriesDialog").is(":visible");

      if (data.message == "Synchronization preview complete" && catSyncDialog) {
        $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
        $(".sync-actions > .doNsSyncBtn").removeAttr("disabled");
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        return;
      }

      if (
        data.message == "Refreshing the page so the Items show up" ||
        data.message == "Synchronization complete." ||
        data.message == "Refreshing the page so the Item's inventory show up" ||
        data.message == "Zero EOS Inventory failed."
      ) {
        $(".currentStatus .progress-spin").hide();
        if (data.message == "Zero EOS Inventory failed.") {
          $(".currentStatus .success-img").hide();
          $(".currentStatus .fail-img").removeClass("hide").show();
        } else {
          $(".currentStatus .success-img").removeClass("hide").show();
          $(".currentStatus .fail-img").hide();
        }

        let _this = this;
        setTimeout(function() {
          _this.refresh();
        }, 2000);
        return;
      }

        var bat = $(".categ_netsuite_sync").length == 1;
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".netsuiteSyncBtn").show();
            $(".netsuiteSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $('.success-img').show();
            $(".currentStatusDesc_Category").text(PREVIEW_READY_TEXT)
        }
        if (!data.inProgress && data.success && !bat) {
            $("#last_update").show();
        }
    }

    // SC-6244: the preview's totals under the status, only once the preview is ready; hidden while a run is going.
    showPreviewSummary(data: NetsuiteProgressChannelData): void {
        const box = $(".sync-preview-summary");
        const summary = data.previewSummary;
        if (data.message != PREVIEW_COMPLETE || !summary) {
            box.addClass("hide");
            return;
        }
        const money = (value: number) => value.toLocaleString("en-US", { style: "currency", currency: "USD" });
        box.find(".js-depleted-units").text((-summary.depleted_units).toLocaleString("en-US"));
        box.find(".js-depleted-value").text(money(summary.depleted_value));
        box.find(".js-depleted-skus").text(summary.depleted_skus.toLocaleString("en-US"));
        box.find(".js-added-units").text(`+${summary.added_units.toLocaleString("en-US")}`);
        box.find(".js-added-value").text(`+${money(summary.added_value)}`);
        box.find(".js-added-skus").text(summary.added_skus.toLocaleString("en-US"));
        box.find(".js-refresh-preview").removeAttr("disabled");
        box.removeClass("hide");
    }

    // SC-6244: run the same preview again from the dialog (it recalculates the compare first), without a page reload.
    refreshPreview(): void {
        const continueBtn = $(".netsuitecontinueBtn");
        if (!continueBtn.length) {
            this.refresh();
            return;
        }
        $(".sync-preview-summary").addClass("hide");
        $(".sync-actions > .previewSyncBtn, .sync-actions > .netsuiteSyncBtn").attr("disabled", "disabled");
        $(".currentStatus .success-img, .currentStatus .fail-img").hide();
        $(".currentStatus .progress-spin").show();
        $(".currentStatusDesc_Category").css("color", "").text("Refreshing the compare and creating a new preview ...");
        continueBtn.trigger("click");
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new NetsuiteProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new NetsuiteProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new NetsuiteProgressUpdate();
    });
}
